import styled from "styled-components";

export const PreviewContainer = styled.div`
  margin: 0 auto;
  /* 启用容器查询，基于父容器宽度调整子元素样式 */
  container-type: inline-size;

  /* Preview top section */
  .preview-top {
    height: 250px;
    position: relative;
  }
  .preview-banner {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .preview-top-shadow {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    // height: 70px;
    padding: 5px 20px 15px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
  }
  .preview-headline {
    font-size: 26px;
    font-weight: 700;
    line-height: 32px;
    color: #fff;
  }
  .preview-subtitle {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #fff;
  }

  /* Preview content section */
  .preview-content {
    /* 手机端默认 padding: 四周 20px */
    padding: 20px;
    
    /* Web 端 (屏幕宽度 >= 768px): 上下 20px, 左右 50px */
    @media (min-width: 768px) {
      padding: 20px 50px;
    }
  }
  .preview-date-enroll {
    display: flex;
    justify-content: space-around;
    margin-top: 16px;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #3D3B48;
  }
  .preview-date-enroll-line {
    width: 2px;
    height: 20px;
    background-color: #999;
    margin: 0 10px;
  }
  .preview-about {
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    margin-top: 20px;
    color: #3D3B48;
  }
  .preview-about-content {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 8px;
    color: #3D3B48;
    white-space: pre-wrap;
    word-break: break-word;
  }

  /* Coach card section */
  .preview-coach-card {
    margin-top: 20px;
    padding: 20px;
    background-color: #f7f7f6;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .preview-coach-header {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .preview-coach-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .preview-coach-name {
    font-size: 18px;
    font-weight: 600;
    color: #3D3B48;
  }
  .preview-coach-subscribers {
    font-size: 16px;
    color: #547756;
  }
  .preview-coach-link {
    font-size: 16px;
    cursor: pointer;
    transition: color 0.3s;
    color: #3D3B48;
    text-decoration: underline;
  }
  .preview-coach-link .link-icon {
    font-size: 16px;
    margin-right: 6px;
  }
  .preview-coach-link:hover {
    color: #547756;
  }
  .preview-coach-description {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #3D3B48;
  }
`;

